import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import AdminDashboard from './dashboards/AdminDashboard';
import StudentDashboard from './dashboards/StudentDashboard';
import TeacherDashboard from './dashboards/TeacherDashboard';
import ContentEditorDashboard from './dashboards/ContentEditorDashboard';
import ContentApproverDashboard from './dashboards/ContentApproverDashboard';
import OnlineLectureCreatorDashboard from './dashboards/OnlineLectureCreatorDashboard';
import CoachAdminDashboard from './dashboards/CoachAdminDashboard';
import DeveloperDashboard from './dashboards/DeveloperDashboard';

import { getUserDetail } from '../../api/UserDetail';
import { error } from '../../components/Notification'; 
import { updateUser } from '../../redux/actions/userAction'
import ContentManagerDashboard from './dashboards/ContentManagerDashboard';
import DataAnalystDashboard from './dashboards/DataAnalystDashboard';

const Home = ({  setUser }) => {
    const User = JSON.parse(localStorage.getItem('user'));

    console.log("user",User);
    // 🔁 Rehydrate Redux ONCE after refresh
    // useEffect(() => {
    //     const storedUser = JSON.parse(localStorage.getItem('user'));

    //     if ( storedUser) {
    //         setUser(storedUser);

    //         // Optional: refresh user details from API
    //         (async () => {
    //             const res = await getUserDetail(
    //                 { UserId: storedUser.Id },
    //                 storedUser.Token
    //             );

    //             if (res.status === 200) {
    //                 const updatedUser = {
    //                     ...storedUser,
    //                     ...res.data,
    //                     Role: res.data.Role,
    //                     Token: storedUser.Token,
    //                     statusSummary: res.data.CmsWorkCount
    //                 };

    //                 localStorage.setItem('user', JSON.stringify(updatedUser));
    //                 setUser(updatedUser);
    //             } else {
    //                 error(res, 2000);
    //             }
    //         })();
    //     }
    // }, []);

    if (!User) {
        return <div>Loading...</div>;
    }

    switch (User.Role) {
        case 'Administrators':
            return <AdminDashboard />;
        case 'Students':
            return <StudentDashboard />;
        case 'Teachers':
        case 'TeacherEditors':
            return <TeacherDashboard />;
        case 'ContentEditors':
            return <ContentEditorDashboard />;
        case 'ContentApprovers':
            return <ContentApproverDashboard />;
        case 'OnlineLectureContentCreator':
            return <OnlineLectureCreatorDashboard />;
        case 'CoachAdmins':
            return <CoachAdminDashboard />;
        case 'Developers':
            return <DeveloperDashboard />;
        case 'DataAnalysts':
            return <DataAnalystDashboard />;
        case 'ContentManagers':
            return <ContentManagerDashboard />;
        default:
            return <div>Loading...</div>;
    }
};

const mapStateToProps = (state) => ({
    User: state.userReducer.User,
});

const mapDispatchToProps = (dispatch) => ({
    setUser: (user) => dispatch(updateUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
